var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationSurferCommuter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 387,
    height: 357,
    viewBox: "0 0 387 357",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "wflyzrwrta",
    d: "M0 0h38.581v31.47H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "3eg15tivec",
    d: "M0 0h385v112.388H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.976 99.316c119.03 20.99 186.745 10.75 220.506 5.678l-11.32-17.113L385 75.91c-29.005-16.138-87.153-48.572-206.184-69.56C152.937 1.785 129.861 0 109.59 0 36.62.001 0 23.138 0 23.138s38.944 55.189 157.976 76.178z",
    id: "pfvu57vahe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "3yvgh7ulpg",
    d: "M0 0h38.581v31.47H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FEFEFE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 79.137S59.784 41.36 178.815 62.35C297.845 83.337 355.995 115.77 385 131.91l-17.84 11.972 11.32 17.113c-33.76 5.07-101.476 15.31-220.505-5.678C38.945 134.326 0 79.137 0 79.137M162.045 161.156a5.433 5.433 0 0 1-6.326 3.493c-3.447-.778-7.787-1.831-9.432-2.54-2.898-1.253-.477-5.105-.477-5.105s-3.449 2.933-5.156 2.504c-1.71-.427.348-6.405.348-6.405l12.348 1.457 10.121 2.534-1.426 4.062z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M176 54v10l6-5.385z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E10A0A",
    strokeWidth: 3.408,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m133 134-27-10"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FEFEFE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m219.121 180.191-57.023 63.463-15.373 95.868h-17.404l2.545-111.653c.06-2.675.673-5.31 1.799-7.735l36.649-78.951 29.326-.622 19.481 39.63z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m306.785 301.623-72.068-62.11L227.406 135l-57.092 6.182 27.675 113.443a16.021 16.021 0 0 0 7.714 10.178l93.95 52.762 7.132-15.942zM147.554 357l-.829-17.477h-17.403c-8.253 5.825-19.027 10.54-32.322 14.149V357h31.493l10.773-1.665V357h8.288zM323 308.028l-16.214-6.404-7.133 15.942c1.355 7.067-.23 12.844-.935 21.782l-7.774 13.578 4.902 1.41 11.627-11.608 7.714-17.24 2.904-10.552 1.512.683 3.397-7.591z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M176 35.385 182.34 59l9.66-3.676L184.581 31z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.968 25.467c1.699-5.027 2.03-10.487-.382-15.496-6.95-14.432-26.29-2.928-27.322 6.168-1.03 9.095 7.01 27.913 12.733 27.182 2.281-.292 6.168-3.36 9.577-7.859l5.124 21.075 16.628-6.637-16.358-24.433z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.765 34.916c-.059 1.604-4.402-.007-7.353 1.288l-1.665-3.219c1.426-.57 9.154-1.719 9.018 1.93M162.172 24.993l-.028 8.187a.57.57 0 0 0 .78.532l3.868-1.544-4.62-7.175zM202.454 35.964s22.668 9.288 23.75 39.246C227.283 105.17 252 188.697 252 188.697s-43.861 9.944-78.864 4.851c0 0-21.24-51.829-9.872-92.274 11.368-40.444 23.633-57.52 39.19-65.31",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(155.266)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "3h8tf083ab",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wflyzrwrta"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.721 31.47s-5.192-3.673-7.223-10.44c-1.34-4.465-6.905-2.972-4.807 2.645l-2.734.405s-.66-3.332-3.583-6.165c-2.923-2.831-3.677-6.609-2.734-7.742 0 0-9.282 10.17-16.64 5.005C5.91 12.13 7.273-3.368 25.57.665c16.848 3.712 12.653 20.587 12.283 22.16-1.013 4.298-.603 7.04-.132 8.645",
    fill: "#FEFEFE",
    mask: "url(#3h8tf083ab)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m202.454 35.964-5.385-6.59s-18.847 15.878-23.933 20.671l8.675 9.587 20.643-23.668zM141.886 128.784l-11.496-.272c-3.716-4.12-6.457-5.741-8.221-4.867-1.48 1.448 3.781 4.889.964 5.684-2.817.793-11.411-.599-12 .89-.871 2.205 2.733 5.724 5.488 6.976 5.15 2.343 9.612 2.048 15.812-.211 0 0 8.258.246 13.563 1.028l-4.11-9.228z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M145.493 124H137v17.84l9 .16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.806 124.415s42.351.043 48.935-25.44c6.584-25.482-5.625-49.996 13.019-51.564 21.398-1.798 20.461 52.721 2.953 77.004-17.506 24.283-64.416 20.264-64.416 20.264l-.491-20.264z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m201.27 35.57-6.288 23.684-5.682-3.298v7.195s-13.51 9.78-26.317 34.569c0 0 9.233-36.083 25.556-52.715 11.94-13.484 12.732-9.435 12.732-9.435",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.315 62.422s-19.092 29.602 5.02 45.9c19.085 12.9 47.035 15.94 61.482 22.463 3.805 1.718 7.578-2.62 7.578-2.62s-2.713-8.09-7.185-10.029c-6.798-2.949-18.777-7.538-35.977-11.94-25.527-6.532-41.124-20.064-30.918-43.774M145.026 157.613s1.552-4.248 2.792-4.549c1.638-.396 9.695 2.21 13.86 3.182l.16 1.612-1.578 3.403-10.39-1.345-4.844-2.303z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 55.612)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "gmylesp3vd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#3eg15tivec"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 23.218S59.784-14.692 178.815 6.37c119.031 21.06 177.18 53.607 206.186 69.803l-17.84 12.013 11.32 17.172c-33.76 5.088-101.476 15.363-220.506-5.698C38.945 78.597 0 23.218 0 23.218",
    fill: "#FE912A",
    mask: "url(#gmylesp3vd)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 56)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "iqz1a7o0cf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pfvu57vahe"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#AAE2BC",
    xlinkHref: "#pfvu57vahe"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9C3A83",
    mask: "url(#iqz1a7o0cf)",
    d: "m0 23.136 393.745 54.55-2.927 29.92z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M163.604 160.584c-.895 2.448-3.557 3.862-6.193 3.29-3.374-.733-7.622-1.725-9.232-2.393-2.837-1.18-.467-4.807-.467-4.807s-3.376 2.762-5.048 2.358c-1.673-.402.341-6.032.341-6.032l12.087 1.372 9.908 2.387-1.396 3.825z",
    fill: "#BA7A45"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E10A0A",
    d: "M180 54v10l6-5.385z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E10A0A",
    strokeWidth: 3.408,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m135 134-27-10"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m225.533 174.422-60.435 69.232-15.373 95.868H132.32l2.545-111.652c.06-2.676.672-5.31 1.799-7.737l36.65-78.95 29.325-.622 22.893 33.86z",
    fill: "#007371"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m309.785 301.623-72.068-62.11L230.406 135l-57.092 6.182 27.675 113.443a16.021 16.021 0 0 0 7.714 10.178l93.95 52.762 7.132-15.942z",
    fill: "#007371"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m150.554 357-.829-17.477h-17.403c-8.253 5.825-19.027 10.54-32.322 14.149V357h31.493l10.773-1.665V357h8.288zM326 308.028l-16.214-6.404-7.133 15.942c1.355 7.067-.23 12.844-.935 21.782l-7.774 13.578 4.902 1.41 11.627-11.608 7.714-17.24 2.904-10.552 1.512.683 3.397-7.591z",
    fill: "#22244E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#BA7A45",
    d: "M179 35.385 185.34 59l9.66-3.676L187.581 31z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M190.968 25.467c1.699-5.027 2.03-10.487-.382-15.496-6.95-14.432-26.29-2.928-27.322 6.168-1.03 9.095 7.01 27.913 12.733 27.182 2.281-.292 6.168-3.36 9.577-7.859l5.124 21.075 16.628-6.637-16.358-24.433z",
    fill: "#BA7A45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.765 34.916c-.059 1.604-4.402-.007-7.353 1.288l-1.665-3.219c1.426-.57 9.154-1.719 9.018 1.93",
    fill: "#22244E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m164.172 24.993-.028 8.187a.57.57 0 0 0 .78.532l3.868-1.544-4.62-7.175z",
    fill: "#BA7A45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.454 35.964s22.668 9.288 23.75 39.246C229.283 105.17 254 188.697 254 188.697s-43.861 9.944-78.864 4.851c0 0-21.24-51.829-9.872-92.274 11.368-40.444 23.633-57.52 39.19-65.31",
    fill: "#22244E"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(157.266)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "qyhw174syh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#3yvgh7ulpg"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.721 31.47s-5.192-3.673-7.223-10.44c-1.34-4.465-6.905-2.972-4.807 2.645l-2.734.405s-.66-3.332-3.583-6.165c-2.923-2.831-3.677-6.609-2.734-7.742 0 0-9.282 10.17-16.64 5.005C5.91 12.13 7.273-3.368 25.57.665c16.848 3.712 12.653 20.587 12.283 22.16-1.013 4.298-.603 7.04-.132 8.645",
    fill: "#22244E",
    mask: "url(#qyhw174syh)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m204.454 35.964-5.385-6.59s-18.847 15.878-23.933 20.671l8.675 9.587 20.643-23.668z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.886 128.784-11.496-.272c-3.716-4.12-6.457-5.741-8.221-4.867-1.48 1.448 3.781 4.889.964 5.684-2.817.793-11.411-.599-12 .89-.871 2.205 2.733 5.724 5.488 6.976 5.15 2.343 9.612 2.048 15.812-.211 0 0 8.258.246 13.563 1.028l-4.11-9.228z",
    fill: "#BA7A45"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M147.493 124H139v17.84l9 .16z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M148 124.23s42.118.043 48.665-25.387c6.548-25.43-5.594-49.893 12.947-51.457 21.28-1.795 20.348 52.611 2.937 76.844-17.41 24.233-64.06 20.222-64.06 20.222L148 124.23z",
    fill: "#383A60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m205.147 35.569-6.254 23.635-5.65-3.291v7.18s-13.435 9.76-26.172 34.497c0 0 9.182-36.009 25.415-52.605 11.874-13.457 12.661-9.416 12.661-9.416",
    fill: "#22244E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.33 62.366s-18.987 29.54 4.99 45.804c18.98 12.874 46.777 15.908 61.143 22.417 3.784 1.714 7.537-2.615 7.537-2.615s-2.698-8.073-7.145-10.008c-6.76-2.943-18.673-7.522-35.779-11.916-25.385-6.518-40.896-20.021-30.746-43.682",
    fill: "#D9ABDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.214 157.36s1.543-4.24 2.776-4.54c1.629-.395 9.641 2.206 13.784 3.175l.158 1.609-1.568 3.396-10.333-1.342-4.817-2.298z",
    fill: "#BA7A45"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#22244E",
    d: "M108 121.485 118.332 130l2.668-.099L109.377 120z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationSurferCommuter);
export default __webpack_public_path__ + "static/media/illustration-surfer-commuter.94f9539042aee6b129e07bd0f3a22f13.svg";
export { ForwardRef as ReactComponent };